import React, { Component, Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import {
	Badge,
	Button,
	Card,
	Col,
	Icon,
	Input,
	message,
	Modal,
	notification,
	Popconfirm,
	Row,
	Slider,
	Upload,
	Tooltip,
} from 'antd'
import Texty from 'rc-texty'
import 'rc-texty/assets/index.css'
import UploadDir from './UploadDir'
import dog from '../images/dog_ate_404.png'
import logo from '../images/icons/logo.png'
import { detect } from 'detect-browser'
import gifshot from 'gifshot'
import { delay } from '../Utils/helpers'
const browser = detect()

notification.config({
	duration: 999999,
})

const { innerWidth, innerHeight } = window

const getVideoConstraints = (innerWidth) => {
	if (innerWidth >= 1365) {
		return {
			audio: false,
			video: {
				width: 640,
				height: 480,
				facingMode: 'user',
			}, // qvga resolution & facingMode can be set to "environment"
		}
	} else if (innerWidth >= 1024 && innerWidth < 1365) {
		return {
			audio: false,
			video: {
				width: 320,
				height: 240,
				facingMode: 'user',
			}, // qvga resolution & facingMode can be set to "environment"
		}
	} else if (innerWidth < 1024) {
		return {
			audio: false,
			video: {
				width: 320 * 0.6,
				height: 240 * 0.6,
				facingMode: 'user',
			}, // qvga resolution & facingMode can be set to "environment"
		}
	}
}

class Teach extends Component {
	constructor(props) {
		super(props)
		this.state = {
			ml5: null,
			featureExtractor: null,
			knnClassifier: null,
			videoPlaying: false,
			isBackFacingCam: true,
			classCount: null,
			IMAGE_SIZE: 227, // Webcam Image size. Must be 227.
			K: 10,
			showClassCountSetter: true,
			showWakeUpMachine: false,
			machineAwake: false,
			countByClassIndexObject: {},
			REQUIRED_TRAINING_COUNT: 25,
			loading: false,
			modelLoading: true,
			initialTrainingInProgress: true,
			videoCropped: false,
			classLabelObject: {},
			classLabelingModalVisible: false,
			allClassesHaveLabels: false,
			uniqueClassLabels: true,
			MIN_CLASSES_ALLOWED: 2,
			MAX_CLASSES_ALLOWED: 5,
			MAX_CLASS_LABEL_LENGTH: 32,
			CLASSIFY_INTERVAL_IN_MS: 1000,
			CLASSIFY_NON_RESPONSE_CHECK_INTERVAL_IN_MS: 5000,
			RECORDED_FOOTAGE_INTERVAL_IN_MS: 1000, // image recorded every MS
			RECORDED_FOOTAGE_IMAGE_QUALITY: 0.5, // 0.1 - 1.0
			RECORDED_FOOTAGE_MAX_IMAGES_ALLOWED: 60, // max # of images used to create GIF
			RAW_FOOTAGE_WIDTH: 640,
			RAW_FOOTAGE_HEIGHT: 480,
			predictedClassIndex: null,
			predictedClassConfidence: null,
			videoClassifierRunning: false,
			fileClassifierRunning: false,
			videoConstraints: getVideoConstraints(innerWidth),
			videoContainerPosition: {
				top: 120,
				left: 60,
			},
			videoError: null,
			videoSuccess: null,
			Canvas: null,
			Pointer: null,
			croppedWidth: 0,
			croppedHeight: 0,
			croppedX: 0,
			croppedY: 0,
			resetCrop: false,
			fileTrainingRunning: false,
			showTrainingInprogressModal: false,
			atTrainingStartCountByClassIndexObject: {},
			currentTrainingClassIndex: null,
			uploadedFileList: null,
		}
	}

	componentDidMount() {
		// You can inject a script tag manually like this,
		// Load ml5
		const ml5 = document.createElement('script')
		ml5.src = 'https://unpkg.com/ml5@0.6.0/dist/ml5.min.js'
		ml5.async = true
		ml5.onload = () => {
			this.setState(
				{
					ml5: window.ml5,
				},
				() => {
					// ml5 is ready
					this.setup()
				}
			)
		}
		document.body && document.body.appendChild(ml5)

		// load Canvas Script
		const Canvas = document.createElement('script')
		Canvas.src = 'https://gustavgenberg.github.io/handy-front-end/Canvas.js'
		Canvas.async = true
		Canvas.onload = () => {
			this.setState({
				Canvas: window.Canvas,
			})
		}
		document.body && document.body.appendChild(Canvas)

		// load Pointer script
		const Pointer = document.createElement('script')
		Pointer.src = 'https://gustavgenberg.github.io/handy-front-end/Pointer.js'
		Pointer.async = true
		Pointer.onload = () => {
			this.setState({
				Pointer: window.Pointer,
			})
		}
		document.body && document.body.appendChild(Pointer)
		this.croppedWidth = 0
		this.croppedHeight = 0
		this.croppedX = 0
		this.croppedY = 0
		this.initVideo()
		this.tempImageContainer = document.getElementById('temp-image')

		// gif generator support check
		this.isExistingImagesGIFSupported = gifshot.isExistingImagesGIFSupported()
		// initialize footage images array
		this.footageImages = []
	}

	componentWillUnmount() {
		if (this.classifierNonResponseIntervalCheck) {
			clearInterval(this.classifierNonResponseIntervalCheck)
		}
	}

	initVideo = async (e) => {
		try {
			const stream = await navigator.mediaDevices.getUserMedia({
				audio: false,
				video: {
					width: this.state.RAW_FOOTAGE_WIDTH,
					height: this.state.RAW_FOOTAGE_HEIGHT,
					facingMode: 'user',
				},
			})
			this.handleVideoSuccess(stream)
		} catch (e) {
			this.handleVideoError(e)
		}
	}

	handleVideoSuccess(stream) {
		if (this.state.videoError) {
			this.setState({ videoError: null })
		}
		this.video = document.getElementById('main-video')
		this.videoTracks = stream.getVideoTracks()
		// console.log('Got stream with constraints:', this.state.videoConstraints)
		console.log(`Using video device: ${this.videoTracks[0].label}`)
		window.stream = stream // make variable available to browser console
		this.video.srcObject = stream

		// now add it to canvas
		this.mainCanvas = document.getElementById('main-canvas')
		const mainCtx = document.getElementById('main-canvas').getContext('2d')
		// set canvas size = video size when known
		this.video.addEventListener('loadedmetadata', () => {
			this.mainCanvas.width = this.state.videoConstraints.video.width
			this.mainCanvas.height = this.state.videoConstraints.video.height
		})
		// draw on main-canvas
		this.video.addEventListener('play', () => {
			if (!this.state.videoSuccess) {
				this.setState({ videoSuccess: true })
			}
			const step = () => {
				// image flip logic
				if (!this.state.isBackFacingCam) {
					mainCtx.setTransform(-1, 0, 0, 1, this.mainCanvas.width, 0)
				} else {
					mainCtx.setTransform(1, 0, 0, 1, 1, 0)
				}
				mainCtx.drawImage(
					this.video,
					0,
					0,
					this.mainCanvas.width,
					this.mainCanvas.height
				)
				requestAnimationFrame(step)
			}
			requestAnimationFrame(step)
		})
	}

	handleVideoError = (err) => {
		//log to console first
		this.setState({ videoError: err.name })
		console.log('video error:', err.name) /* handle the error */
		if (err.name === 'NotFoundError' || err.name === 'DevicesNotFoundError') {
			//required track is missing
			notification['error']({
				message: <div>No webcam connected</div>,
			})
			console.log('No webcam connected')
		} else if (
			err.name === 'NotReadableError' ||
			err.name === 'TrackStartError'
		) {
			//webcam or mic are already in use
			notification['error']({
				message: 'Webcam is already in use by another site/app',
			})
			console.log('Webcam is already in use by another site/app')
		} else if (
			err.name === 'OverconstrainedError' ||
			err.name === 'ConstraintNotSatisfiedError'
		) {
			//constraints can not be satisfied by avb. devices
			notification['error']({
				message: 'Set video constraints cannot be satisfied by the webcam',
			})
			console.log('Set video constraints cannot be satisfied by the webcam')
		} else if (
			err.name === 'NotAllowedError' ||
			err.name === 'PermissionDeniedError'
		) {
			console.log('User denied permission to access webcam')
			// notification['error']({
			//   message: 'User denied permission to access webcam',
			// })
			switch (browser && browser.name) {
				case 'chrome':
					notification['error']({
						message: (
							<div>
								The AI can be trained using the webcam. To do this, you need to
								click this icon <i class="fa fa-video-camera" /> above to turn
								on your camera and then{' '}
								<span
									onClick={this.reloadPage}
									style={{
										cursor: 'pointer',
										color: '#1890ff',
										fontStyle: 'bold',
									}}
								>
									Refresh the Page
								</span>{' '}
								and allow camera access.
							</div>
						),
					})
					break
				case 'firefox':
					notification['error']({
						message: (
							<div>
								The AI can be trained using the webcam. To do this, you need to
								click this icon <i class="fa fa-video-camera" /> to grant access
								and{' '}
								<span
									onClick={this.reloadPage}
									style={{
										cursor: 'pointer',
										color: '#1890ff',
										fontStyle: 'bold',
									}}
								>
									Refresh the Page
								</span>
								e.
							</div>
						),
					})
					break

				case 'edge':
					console.log('kinda ok')
					break
				case 'safari':
					notification['error']({
						message: (
							<div>
								The AI can be trained using the webcam. To do this, click
								"Safari" in the menu bar, navigate to "Settings for This
								Website", in the "Camera" drop down menu choose "Allow" and then{' '}
								<span
									onClick={this.reloadPage}
									style={{
										cursor: 'pointer',
										color: '#1890ff',
										fontStyle: 'bold',
									}}
								>
									Refresh the Page
								</span>
								.
							</div>
						),
					})
					break
				default:
					notification['error']({
						message: (
							<div>
								The AI can be trained using the webcam. To do this, you need
								give this App permission to access the webcam.
							</div>
						),
					})
			}
			//permission denied in browser
		} else if (err.name === 'TypeError' || err.name === 'TypeError') {
			//empty constraints object
			notification['error']({
				message: 'Empty video constraints Object',
			})
			console.log('Empty video constraints Object')
		} else {
			//other errors
			console.log(
				'Unknown error occurred while trying to load video from webcam'
			)
			notification['error']({
				message:
					'Unknown error occurred while trying to load video from webcam',
			})
		}
	}

	setupRectCanvas = () => {
		const {
			Canvas,
			Pointer,
			videoCropped,
			videoConstraints,
			videoError,
			fileTrainingRunning,
			showClassCountSetter,
			initialTrainingInProgress,
		} = this.state
		if (
			Canvas &&
			Pointer &&
			videoConstraints &&
			videoConstraints.video &&
			videoConstraints.video.width &&
			videoConstraints.video.height &&
			!videoCropped &&
			!initialTrainingInProgress &&
			!this.rectCanvasCreated
		) {
			this.rectCanvasCreated = true
			const rectCanvas = new Canvas(
				'rect-canvas',
				videoConstraints.video.width,
				videoConstraints.video.height
			)
			const mouse = new Pointer()
			this.rectCanvasRef = document.getElementById('rect-canvas')
			this.rectCanvasRef.style.position = 'absolute'
			this.rectCanvasRef.style.top = `${this.state.videoContainerPosition.top}px`
			this.rectCanvasRef.style.left = `${this.state.videoContainerPosition.left}px`
			this.rectCanvasRef.style.cursor = 'crosshair'
			this.rectCanvasRef.style.display = videoError ? 'none' : 'inherent'
			this.rectCanvasRef.style.zIndex = '10'

			this.rectCanvasRef.style.boxSizing = 'padding-box'
			this.rectCanvasRef.style.borderStyle = 'solid'
			this.rectCanvasRef.style.borderWidth = '4px'
			this.rectCanvasRef.style.borderColor = '#f6f6f6'
			this.rectCanvasRef.style.borderRadius = '4px'

			this.rectSquares = []
			let mouseInsideRectCanvas = false
			mouse.on('up', (event) => {
				const { videoCropped, resetCrop } = this.state
				if (event.button === mouse.BTN_LEFT && !videoCropped && !resetCrop) {
					const entry = mouse.getLastClick(mouse.BTN_LEFT)

					const relative = mouse.relative(rectCanvas.element, entry.x, entry.y)
					const endrelative = mouse.relative(
						rectCanvas.element,
						entry.endx,
						entry.endy
					)

					const square = {
						x: Math.min(relative.x, endrelative.x),
						y: Math.min(relative.y, endrelative.y),
						w: Math.max(relative.x - endrelative.x, endrelative.x - relative.x),
						h: Math.max(relative.y - endrelative.y, endrelative.y - relative.y),
					}

					this.rectSquares.push(square)
				}
			})

			const mouseEnter = () => {
				// console.log('mouse entered rectCanvas')
				mouseInsideRectCanvas = true
			}
			const mouseLeave = () => {
				// console.log('mouse left rectCanvas')
				mouseInsideRectCanvas = false
			}
			this.initRectCanvas = () => {
				this.rectCanvasRef.addEventListener('mouseleave', mouseLeave, false)
				this.rectCanvasRef.addEventListener('mouseenter', mouseEnter, false)
			}

			rectCanvas
				.on('draw', (rectCtx, handyObject) => {
					// console.log('rectCanvas draw func ran')
					const { videoCropped, resetCrop } = this.state
					// console.log('reactCanvas videoCropped:', videoCropped)
					// console.log('reactCanvas resetCrop:', resetCrop)

					this.rectCtx = rectCtx
					if (!videoCropped) {
						this.initRectCanvas()
						rectCtx.clear()
						this.rectSquares.forEach((square) => {
							rectCtx.fillRect(square.x, square.y, square.w, square.h)
							rectCtx.fillStyle = 'rgba(255, 99, 71, 0.45)'
						})

						if (!resetCrop) {
							this.rectCanvasRef.style.pointerEvents = 'auto'
							this.rectCanvasRef.style.cursor = 'crosshair'
						}

						if (resetCrop) {
							// console.log(
							//   'rect Canvas func ran with !videoCropped && resetCrop',
							// )
						}

						if (mouse.isDown(mouse.BTN_LEFT)) {
							this.rectCanvasRef.style.visibility = 'visible'

							if (mouseInsideRectCanvas) {
								this.rectSquares.pop()
								const relative_start = mouse.relative(
									rectCanvas.element,
									mouse.mousedown[mouse.BTN_LEFT].x,
									mouse.mousedown[mouse.BTN_LEFT].y
								)
								const relative_current = mouse.relative(
									rectCanvas.element,
									mouse.x,
									mouse.y
								)

								const width = relative_current.x - relative_start.x
								const height = relative_current.y - relative_start.y
								// update the stored croppedWidth and croppedHeight
								const { videoConstraints } = this.state
								const boundedStartX = () => {
									if (relative_start.x > videoConstraints.video.width) {
										return videoConstraints.video.width
									} else if (relative_start.x < 0) {
										return 0
									} else {
										return relative_start.x
									}
								}

								const boundedStartY = () => {
									if (relative_start.y > videoConstraints.video.height) {
										return videoConstraints.video.height
									} else if (relative_start.y < 0) {
										return 0
									} else {
										return relative_start.y
									}
								}

								const boundedCroppedWidth = () => {
									if (relative_start.x > videoConstraints.video.width) {
										return (
											width + (relative_start.x - videoConstraints.video.width)
										)
									} else if (relative_start.x < 0) {
										return width + relative_start.x
									} else {
										return width
									}
								}

								const boundedCroppedHeight = () => {
									if (relative_start.y > videoConstraints.video.height) {
										return (
											height +
											(relative_start.y - videoConstraints.video.height)
										)
									} else if (relative_start.y < 0) {
										return height + relative_start.y
									} else {
										return height
									}
								}
								this.croppedWidth = boundedCroppedWidth()
								this.croppedHeight = boundedCroppedHeight()
								this.croppedX = boundedStartX()
								this.croppedY = boundedStartY()
								if (this.state.croppedWidth !== this.croppedWidth) {
									this.setState({
										croppedWidth: this.croppedWidth,
									})
								}
								if (this.state.croppedHeight !== this.croppedHeight) {
									this.setState({
										croppedHeight: this.croppedHeight,
									})
								}

								if (this.state.croppedX !== this.croppedX) {
									this.setState({
										croppedX: this.croppedX,
									})
								}
								if (this.state.croppedY !== this.croppedY) {
									this.setState({
										croppedY: this.croppedY,
									})
								}
								rectCtx.fillRect(
									relative_start.x,
									relative_start.y,
									width,
									height
								)
								rectCtx.fillStyle = 'rgba(255, 99, 71, 0.45)'
							}
						}
					} else {
						const { videoCropped, showClassCountSetter, resetCrop } = this.state
						this.rectCanvasRef.style.pointerEvents = `${
							!videoCropped && showClassCountSetter ? 'auto' : 'none'
						}`
						this.rectCanvasRef.style.cursor = `${
							videoCropped || !showClassCountSetter ? 'auto' : 'crosshair'
						}`
					}
				})
				.start()
		}
	}
	setup = () => {
		const { ml5 } = this.state
		if (ml5) {
			// Create a featureExtractor that can extract the already learned features from MobileNet
			let featureExtractor = ml5.featureExtractor(
				'MobileNet',
				{ numClasses: this.state.MIN_CLASSES_ALLOWED },
				this.modelReady
			)
			this.setState({ featureExtractor })
		}
	}

	setClassCount = (classCount) => {
		this.setState({ classCount })
		if (!this.state.showWakeUpMachine) {
			this.setState({ showWakeUpMachine: true })
		}
	}

	modelReady = () => {
		// console.log('====================================')
		// console.log('FeatureExtractor(mobileNet model) Loaded')
		// console.log('====================================')
		const knnClassifier = this.state.ml5.KNNClassifier()
		this.setState(
			{
				knnClassifier,
				modelLoading: false,
			},
			() => {
				this.initializeTraining()
			}
		)
	}

	wakeUpMachine = () => {
		this.setState(
			{
				loading: true,
				classLabelingModalVisible: true,
				showClassCountSetter: false,
				showWakeUpMachine: false,
				machineAwake: true,
			},
			() => {
				if (!this.state.videoCropped) {
					this.croppedWidth = 0
					this.croppedHeight = 0
					this.croppedX = 0
					this.croppedY = 0
					this.setState({
						croppedWidth: 0,
						croppedHeight: 0,
						croppedX: 0,
						croppedY: 0,
					})
					this.rectCanvasRef.style.display = 'none'
				}

				if (this.state.featureExtractor && this.state.classCount) {
					const featureExtractor = this.state.featureExtractor.classification({
						numClasses: this.state.classCount,
					})
					this.setState({
						featureExtractor,
					})
				}
			}
		)
	}

	initializeTraining = () => {
		// initialize with test image and all data is removed right after
		const testFile = dog
		this.tempImageContainer.src = testFile

		const features = this.state.featureExtractor.infer(this.tempImageContainer)
		// Add an example with a label to the KNN Classifier
		this.state.knnClassifier.addExample(features, 0)
		this.state.knnClassifier.clearAllLabels()
		this.setState({ initialTrainingInProgress: false })
	}

	trainClass = (e) => {
		if (!this.state.videoError) {
			console.log(`Training class #${Number(e.target.value) + 1}`)
			// Get the features of an image
			const videoFeed = this.state.videoCropped
				? this.croppedCanvas
				: this.mainCanvas

			const features = this.state.featureExtractor.infer(videoFeed)

			// Add an example with a label to the KNN Classifier
			this.state.knnClassifier.addExample(features, `${e.target.value}`)
			this.updateTrainingCount()
		}
	}

	trainClassWithFile = ({ file, classIndex }) => {
		const reader = new FileReader()
		reader.readAsDataURL(file)
		reader.onloadend = () => {
			this.tempImageContainer.src = reader.result
			console.log(`Training class #${Number(classIndex) + 1}`)
			// Get the features of an image

			const features = this.state.featureExtractor.infer(
				this.tempImageContainer
			)

			// Add an example with a label to the KNN Classifier
			this.state.knnClassifier.addExample(features, `${classIndex}`)
			this.updateTrainingCount()
		}
	}

	updateTrainingCount = () => {
		const countByClassIndexObject = this.state.knnClassifier.getCountByLabel()
		this.setState({ countByClassIndexObject }, () => {
			this.handleResetTraining()
		})
	}

	handleResetTraining = () => {
		const {
			currentTrainingClassIndex,
			atTrainingStartCountByClassIndexObject,
			countByClassIndexObject,
			uploadedFileList,
		} = this.state

		if (
			currentTrainingClassIndex &&
			atTrainingStartCountByClassIndexObject &&
			countByClassIndexObject &&
			uploadedFileList
		) {
			const newCount = countByClassIndexObject[`${currentTrainingClassIndex}`]
			const previousCount =
				atTrainingStartCountByClassIndexObject[`${currentTrainingClassIndex}`]
			const uploadedTrainingImagesCount = Object.keys(uploadedFileList).length

			if (newCount >= previousCount + uploadedTrainingImagesCount) {
				this.setState({
					fileTrainingRunning: false,
					showTrainingInprogressModal: false,
				})

				this.rectCanvasRef.style.pointerEvents = 'auto'
				this.rectCanvasRef.style.cursor = 'crosshair'
			}
		}
	}

	recordFootage = () => {
		if (this.state.videoClassifierRunning) {
			const rawCanvas = document.createElement('canvas')
			rawCanvas.height = this.video.videoHeight
			rawCanvas.width = this.video.videoWidth
			const ctx = rawCanvas.getContext('2d')
			ctx.drawImage(this.video, 0, 0, rawCanvas.width, rawCanvas.height)
			const mediumQuality = rawCanvas.toDataURL(
				'image/jpeg',
				this.state.RECORDED_FOOTAGE_IMAGE_QUALITY
			)
			if (
				this.footageImages.length >
				this.state.RECORDED_FOOTAGE_MAX_IMAGES_ALLOWED
			) {
				// this will delete first element in array
				console.log('1st footage frame removed')
				this.footageImages.shift()
			}
			console.log('footage frame added to array')
			this.footageImages.push(mediumQuality)
			setTimeout(() => {
				this.recordFootage()
			}, this.state.RECORDED_FOOTAGE_INTERVAL_IN_MS)
		}
	}

	startVideoClassifying = () => {
		if (!this.state.videoClassifierRunning && !this.state.videoError) {
			this.setState({ videoClassifierRunning: true }, () => {
				this.classify()
			})
		}
	}

	stopVideoClassifying = () => {
		if (this.state.videoClassifierRunning) {
			this.setState({ videoClassifierRunning: false }, () => {})
		}
	}
	// Predict the current frame.
	classify = async () => {
		if (this.state.videoClassifierRunning) {
			// Get the total number of labels from knnClassifier
			const numLabels = this.state.knnClassifier.getNumLabels()
			if (!numLabels || numLabels <= 0) {
				console.log('There are no labels in classifier')
				return
			}
			// Get the features of the input video
			const videoFeed = this.state.videoCropped
				? this.croppedCanvas
				: this.mainCanvas

			if (!videoFeed) {
				console.log('No videoFeed for feature extraction')
				return
			}
			const features = this.state.featureExtractor.infer(videoFeed)
			if (!features) {
				console.log('No features to classify')
				return
			}
			// console.log('K:', this.state.K)
			// console.log('this.state.knnClassifier:', this.state.knnClassifier)
			// // Use knnClassifier to classify which label do these features belong to
			// //  You can pass in a callback function `gotResults` to knnClassifier.classify function
			// this.state.knnClassifier.classify(features, this.state.K, this.gotResults)
			// // You can also pass in an optional K value, K default to 3
			// // knnClassifier.classify(features, 3, gotResults);

			// // You can also use the following async/await function to call knnClassifier.classify
			// // Remember to add `async` before `function predictClass()`
			try {
				this.classifierNonResponseIntervalCheck = setInterval(() => {
					console.warn('knnClassifier classifier Stopped responding')
					clearInterval(this.classifierNonResponseIntervalCheck)
				}, this.state.CLASSIFY_NON_RESPONSE_CHECK_INTERVAL_IN_MS)
				const res = await this.state.knnClassifier.classify(
					features,
					this.state.K
				)
				clearInterval(this.classifierNonResponseIntervalCheck)
				this.gotResults(null, res)
			} catch (error) {
				console.log('classify error:', error)
			}
		}
	}

	gotResults = (err, result) => {
		if (this.state.videoClassifierRunning) {
			// Display any error
			if (err) {
				console.log('gotResults error:', err)
			} else {
				if (result.confidencesByLabel) {
					const confidences = result.confidencesByLabel
					// result.label is the label that has the highest confidence
					if (result.label) {
						this.setState({
							predictedClassIndex: result.label,
							predictedClassConfidence: confidences[result.label],
						})
						console.log(
							`prediction: ${
								this.state.classLabelObject[result.label]
									? this.state.classLabelObject[result.label]
									: `Class #${Number(result.label) + 1}`
							} with ${confidences[result.label] * 100} %`
						)
					}
				}
			}
			setTimeout(() => {
				this.classify()
			}, this.state.CLASSIFY_INTERVAL_IN_MS)
		}
	}

	// Predict the uploaded image.
	classifyFile = ({ file }) => {
		if (this.state.fileClassifierRunning) {
			// Get the total number of labels from knnClassifier
			const numLabels = this.state.knnClassifier.getNumLabels()
			if (numLabels <= 0) {
				console.error('There are no labels in classifier')
				return
			}
			const reader = new FileReader()
			reader.readAsDataURL(file)
			reader.onloadend = () => {
				this.tempImageContainer.src = reader.result
				// Get the features of an image

				const features = this.state.featureExtractor.infer(
					this.tempImageContainer
				)

				// Use knnClassifier to classify which label do these features belong to
				// You can pass in a callback function `gotResults` to knnClassifier.classify function
				this.state.knnClassifier.classify(
					features,
					this.state.K,
					this.gotFileResult
				)
				// You can also pass in an optional K value, K default to 3
				// knnClassifier.classify(features, 3, gotResults);

				// You can also use the following async/await function to call knnClassifier.classify
				// Remember to add `async` before `function predictClass()`
				// const res = await knnClassifier.classify(features);
				// gotResults(null, res);
			}
		}
	}

	gotFileResult = (err, result) => {
		if (this.state.fileClassifierRunning) {
			// Display any error
			if (err) {
				console.error(err)
			}
			if (result.confidencesByLabel) {
				const confidences = result.confidencesByLabel
				// result.label is the label that has the highest confidence
				if (result.label) {
					this.setState({
						predictedClassIndex: result.label,
						predictedClassConfidence: confidences[result.label],
					})
					console.log(
						`prediction: ${
							this.state.classLabelObject[result.label]
								? this.state.classLabelObject[result.label]
								: `Class #${Number(result.label) + 1}`
						} with ${confidences[result.label] * 100} %`
					)
					const d = new Date()
					const now = d.getTime()
					this.gotFileResultNotificationKey = now
					notification['success']({
						message: `The AI predicts the uploaded image is of Class: ${
							this.state.classLabelObject[result.label]
						} & it is ${confidences[result.label] * 100}% confident.`,
						duration: 8,
						placement: 'bottomRight',
						key: now,
						onClose: () => this.stopFileClassifying(),
					})
				}
			}
		}
	}

	startFileClassifying = ({ file }) => {
		notification.close(this.gotFileResultNotificationKey)
		this.setState({ fileClassifierRunning: true }, () => {
			this.classifyFile({ file })
		})
	}

	stopFileClassifying = () => {
		if (this.state.fileClassifierRunning) {
			this.setState({ fileClassifierRunning: false }, () => {})
		}
	}

	createGifFromFootageImages = () => {
		// console.log('this.footageImages length:', this.footageImages.length)
		const imageArray = this.footageImages
		if (this.isExistingImagesGIFSupported) {
			gifshot.createGIF(
				{
					images: imageArray,
					// gifWidth: 360 * (this.video.width / this.video.height).toFixed(2),
					// gifHeight: 360,
					gifWidth: this.video.width,
					gifHeight: this.video.height,
					interval: 1, // seconds between each gif frame
					text: '',
					fontWeight: 'normal',
					fontSize: '16px',
					fontFamily: 'sans-serif',
					fontColor: '#ffffff',
					textAlign: 'center',
					textBaseline: 'bottom',
					numWorkers: 2,
				},
				(obj) => {
					if (!obj.error) {
						const image = obj.image
						let animatedImage = document.createElement('img')
						animatedImage.src = image
						document.body.appendChild(animatedImage)
					}
				}
			)
		}
	}

	handleCreatingCroppedCanvas = () => {
		this.setState(
			{
				videoCropped: true,
				resetCrop: false,
			},
			() => {
				this.drawCroppedCanvas()
			}
		)
	}
	drawCroppedCanvas = () => {
		requestAnimationFrame(this.drawCroppedCanvas)
		this.croppedCanvas = document.getElementById('cropped-canvas')
		this.croppedCtx = this.croppedCanvas.getContext('2d')
		this.croppedCtx.clearRect(
			0,
			0,
			this.croppedCtx.canvas.width,
			this.croppedCtx.canvas.height
		) //clear canvas
		if (this.resetCrop) {
			this.setState({ resetCrop: false })
		}
		this.croppedCtx.drawImage(
			this.mainCanvas,
			this.croppedWidth < 0 ? this.croppedX + this.croppedWidth : this.croppedX,
			this.croppedHeight < 0
				? this.croppedY + this.croppedHeight
				: this.croppedY,
			Math.abs(this.croppedWidth),
			Math.abs(this.croppedHeight),
			0,
			0,
			Math.abs(this.croppedWidth),
			Math.abs(this.croppedHeight)
		)
	}

	resetCrop = () => {
		// console.log('resetCrop clicked')
		this.setState(
			{
				videoCropped: false,
				resetCrop: true,
			},
			() => {}
		)
	}

	reloadPage = () => {
		window.location.reload()
	}
	addAnotherClass = () => {
		const { MAX_CLASSES_ALLOWED, classCount } = this.state
		this.stopVideoClassifying()
		if (classCount < MAX_CLASSES_ALLOWED) {
			this.setState({
				classCount: this.state.classCount + 1,
				classLabelingModalVisible: true,
				allClassesHaveLabels: false,
				videoClassifierRunning: false,
				fileClassifierRunning: false,
				addAnotherClassInProgress: true,
			})
			const featureExtractor = this.state.featureExtractor.classification({
				numClasses: this.state.classCount + 1,
			})
			this.setState({
				featureExtractor,
			})
		}
	}

	undoAddAnotherClass = () => {
		const { MIN_CLASSES_ALLOWED, classCount, addAnotherClassInProgress } =
			this.state
		this.stopVideoClassifying()
		if (classCount > MIN_CLASSES_ALLOWED && addAnotherClassInProgress) {
			this.setState({
				classCount: this.state.classCount - 1,
				classLabelingModalVisible: false,
				allClassesHaveLabels: true,
				videoClassifierRunning: false,
				fileClassifierRunning: false,
				addAnotherClassInProgress: false,
			})
			const featureExtractor = this.state.featureExtractor.classification({
				numClasses: this.state.classCount - 1,
			})
			this.setState({
				featureExtractor,
			})
		}
	}

	clearAllTrainingExamplesInClass = ({ classIndex }) => {
		const { countByClassIndexObject, knnClassifier } = this.state
		this.stopVideoClassifying()
		if (
			countByClassIndexObject[classIndex] &&
			countByClassIndexObject[classIndex] > 0
		) {
			knnClassifier.clearLabel(classIndex)
			this.updateTrainingCount()
		}
	}

	clearAllTrainingForAllClasses = () => {
		const { knnClassifier } = this.state
		this.stopVideoClassifying()
		knnClassifier.clearAllLabels()
		this.updateTrainingCount()
	}

	saveTrainedModel = () => {
		const { knnClassifier } = this.state
		knnClassifier.save(`TrainedModel`)
		this.stopVideoClassifying()
	}

	loadTrainedModel = async ({ file }) => {
		const { knnClassifier } = this.state
		this.stopVideoClassifying()
		const reader = new FileReader()
		reader.readAsDataURL(file)
		reader.onloadend = async () => {
			await knnClassifier.load(reader.result)
			const numLabels = knnClassifier.getNumLabels()
			if (numLabels && numLabels >= 2) {
				this.setState({ classLabelObject: {}, classCount: numLabels }, () => {
					this.updateTrainingCount()
				})
			}
		}
	}

	onClassLabelChange = ({ event, classIndex }) => {
		const { classLabelObject, MAX_CLASS_LABEL_LENGTH } = this.state
		if (event.target.value.length < MAX_CLASS_LABEL_LENGTH) {
			this.setState(
				{
					classLabelObject: {
						...classLabelObject,
						[classIndex]: event.target.value,
					},
				},
				() => {
					const { classLabelObject, classCount } = this.state
					const classLabelsArray = Object.keys(classLabelObject).map((key) =>
						classLabelObject[`${key}`].toUpperCase().trim()
					)
					const uniqueClassLabelsSet = new Set(classLabelsArray)
					const uniqueClassLabelsArray = [...uniqueClassLabelsSet]

					if (classLabelsArray.length !== uniqueClassLabelsArray.length) {
						this.setState({ uniqueClassLabels: false })
					} else {
						this.setState({
							uniqueClassLabels: true,
						})
					}
					const classCountArray = classCount
						? [...Array(classCount).keys()]
						: []
					if (Object.keys(classLabelObject).length === classCountArray.length) {
						let allClassesHaveLabelsArray = []
						classCountArray.map((classIndex) => {
							if (
								typeof classLabelObject[`${classIndex}`] !== 'undefined' &&
								classLabelObject[`${classIndex}`].trim().length > 0
							) {
								allClassesHaveLabelsArray.push(true)
							} else {
								allClassesHaveLabelsArray.push(false)
							}
						})
						if (allClassesHaveLabelsArray.length > 0) {
							const allClassesHaveLabels = allClassesHaveLabelsArray.every(
								(val) => val === true
							)
							this.setState({ allClassesHaveLabels })
						} else {
							this.setState({ allClassesHaveLabels: false })
						}
					}
				}
			)
		}
	}

	showClassLabelModal = () => {
		this.setState({ classLabelingModalVisible: true })
	}

	handleClassLabelingModalOk = () => {
		const { classLabelObject } = this.state
		Object.keys(classLabelObject).map((key) => {
			classLabelObject[key] = classLabelObject[key].trim().toUpperCase()
		})
		this.setState({
			classLabelingModalVisible: false,
			classLabelObject,
			loading: false,
		})
	}

	handleClassLabelingModalCancel = () => {
		this.setState({
			classLabelingModalVisible: false,
			loading: false,
		})
		if (this.state.addAnotherClassInProgress) {
			this.undoAddAnotherClass()
		}
	}

	onClassLabelingEnter = (event, callback) => {
		if (
			this.state.allClassesHaveLabels &&
			this.state.uniqueClassLabels &&
			event.key === 'Enter'
		) {
			this.handleClassLabelingModalOk()
		}
	}

	toggleMirroringOfVideoStream = () => {
		this.setState({ isBackFacingCam: !this.state.isBackFacingCam })
	}

	handleUploadSuccess = ({ fileList, classIndex }) => {
		this.setState({ showTrainingInprogressModal: true }, () => {
			// forced some time for modal to stay showing
			setTimeout(() => {
				const currentCountOfClass =
					this.state.countByClassIndexObject[`${classIndex}`] || 0
				const atTrainingStartCountByClassIndexObject =
					this.state.atTrainingStartCountByClassIndexObject
				this.setState({
					fileTrainingRunning: true,
					atTrainingStartCountByClassIndexObject: {
						...atTrainingStartCountByClassIndexObject,
						[`${classIndex}`]: currentCountOfClass,
					},
					currentTrainingClassIndex: classIndex,
					uploadedFileList: fileList,
				})
				this.rectCanvasRef.style.pointerEvents = 'none'
				this.rectCanvasRef.style.cursor = 'auto'
				fileList.map((file) => {
					this.trainClassWithFile({
						file,
						classIndex,
					})
				})
			}, 1800)
		})
	}

	render() {
		const {
			classCount,
			showClassCountSetter,
			showWakeUpMachine,
			machineAwake,
			ml5,
			featureExtractor,
			knnClassifier,
			countByClassIndexObject,
			REQUIRED_TRAINING_COUNT,
			loading,
			modelLoading,
			videoCropped,
			croppedWidth,
			croppedHeight,
			classLabelObject,
			allClassesHaveLabels,
			uniqueClassLabels,
			classLabelingModalVisible,
			MIN_CLASSES_ALLOWED,
			MAX_CLASSES_ALLOWED,
			predictedClassIndex,
			predictedClassConfidence,
			videoClassifierRunning,
			fileClassifierRunning,
			videoConstraints,
			videoError,
			videoSuccess,
			Canvas,
			Pointer,
			fileTrainingRunning,
			showTrainingInprogressModal,
			initialTrainingInProgress,
		} = this.state
		let classCountArray = classCount ? [...Array(classCount).keys()] : []
		let minimumTrainingMet = false
		let count = 0
		classCountArray.map((classIndex) => {
			if (
				countByClassIndexObject[`${classIndex}`] &&
				countByClassIndexObject[`${classIndex}`] >= REQUIRED_TRAINING_COUNT
			) {
				count = count + 1
			}
		})
		if (count >= 2 && count === classCountArray.length) {
			minimumTrainingMet = true
		}

		const fileClassifyUploaderProps = {
			beforeUpload: (file) => {
				if (
					file.type !== 'image/png' &&
					file.type !== 'image/jpg' &&
					file.type !== 'image/jpeg'
				) {
					notification.destroy()
					notification['error']({
						message:
							'Error! Uploaded file is not a valid image. Only .png and .jpg images are supported.',
						duration: 4.6,
						placement: 'bottomRight',
					})
					return false
				} else {
					this.startFileClassifying({ file })
				}
			},
		}

		const modelFileUploaderProps = {
			beforeUpload: (file) => {
				if (file.type !== 'application/json') {
					notification.destroy()
					notification['error']({
						message:
							'Error! Uploaded file is not a valid model json file. Only valid .json model file are supported.',
						duration: 4.6,
						placement: 'bottomRight',
					})
					return false
				} else {
					this.loadTrainedModel({ file })
				}
			},
		}

		// console.log('this.croppedWidth:', this.croppedWidth)
		// console.log('this.croppedHeight:', this.croppedHeight)
		// console.log('this.croppedX:', this.croppedX)
		// console.log('this.croppedY:', this.croppedY)

		return (
			<div className={'fadeIn'}>
				<Modal
					className="trainingInProgressModal"
					title={
						<div style={{ color: '#1890ff' }}>
							<Icon type="setting" spin /> TRAINING IN PROGRESS
						</div>
					}
					visible={showTrainingInprogressModal}
					footer={[]}
				>
					<p>
						Depending on the # of uploaded files and their sizes, this process
						may take a while.
					</p>
				</Modal>
				<Modal
					style={{ zIndex: '999' }}
					className="creatingMachineInProgressModal"
					title={
						<div style={{ color: '#f2f2f2' }}>
							<Icon type="setting" spin /> AI is being created!
						</div>
					}
					visible={initialTrainingInProgress}
					footer={[]}
				/>

				<div
					className="shadow-effect fadeIn"
					style={{
						width: '100vw',
						textAlign: 'center',
						paddingTop: '1vh',
						paddingBottom: '1vh',
						height: '5vh',
					}}
				>
					{!initialTrainingInProgress ? (
						<div
							style={{
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
							}}
						>
							<div
								style={{
									height: '2.2vh',
									marginRight: '4px',
								}}
							>
								<img src={logo} alt="logo" height={'100%'} width={'auto'} />
							</div>{' '}
							<div
								style={{
									height: '2.2vh',
									fontSize: '1.2em',
								}}
							>
								<Texty>Fiopy | AI in Training</Texty>
							</div>
						</div>
					) : null}
					{minimumTrainingMet &&
					predictedClassIndex &&
					predictedClassConfidence &&
					(videoClassifierRunning || fileClassifierRunning) ? (
						<div
							id={'prediction'}
							className="shadow-effect"
							style={{
								background: '#1890ff',
								color: 'white',
							}}
						>
							<div
								style={{
									display: 'flex',
									justifyContent: 'center',
									alignItems: 'center',
									width: '100vw',
									height: '4vh',
									fontSize: '1em',
									marginTop: '2vh',
									paddingTop: '1vh',
									paddingBottom: '1vh',
								}}
							>
								<div
									style={{
										marginLeft: '25px',
										marginRight: '10px',
									}}
								>
									Predicted Class:
								</div>
								<div
									style={{
										fontSize: '1em',
										color: 'white',
										opacity: '1',
										fontWeight: 500,
									}}
								>
									{classLabelObject[predictedClassIndex]
										? classLabelObject[predictedClassIndex]
										: `Class #${Number(predictedClassIndex) + 1}`}
								</div>
								<div
									style={{
										marginLeft: '25px',
										marginRight: '10px',
									}}
								>
									Confidence:
								</div>
								<div style={{ color: 'white' }}>
									{Number(Number(predictedClassConfidence * 100).toFixed())}%
								</div>
							</div>
						</div>
					) : null}
				</div>
				<img
					src=""
					alt=""
					id="temp-image"
					style={{
						position: 'absolute',
						top: `${
							this.state.videoContainerPosition.top +
							videoConstraints.video.height +
							50
						}px`,
						left: `${this.state.videoContainerPosition.left}px`,
						opacity: '1',
						pointerEvents: 'none',
						objectFit: 'contain',
						boxSizing: 'padding-box',
						borderStyle: 'solid',
						borderWidth: '4px',
						borderColor: '#f6f6f6',
						borderRadius: '4px',
						backgroundColor: '#f6f6f6',
						display: 'none',
					}}
					width={videoConstraints.video.width}
					height={videoConstraints.video.height}
				/>

				<video
					id="main-video"
					style={{
						position: 'absolute',
						top: `${this.state.videoContainerPosition.top}px`,
						left: `${this.state.videoContainerPosition.left}px`,
						pointerEvents: 'none',
						opacity: '0',
						objectFit: 'contain',
						boxSizing: 'padding-box',
						borderStyle: 'solid',
						borderWidth: '4px',
						borderColor: '#f6f6f6',
						borderRadius: '4px',
						backgroundColor: '#f6f6f6',
					}}
					width={this.state.RAW_FOOTAGE_WIDTH}
					height={this.state.RAW_FOOTAGE_HEIGHT}
					autoPlay
					playsInline
				/>
				{!videoSuccess ? (
					<Fragment>
						<Icon
							type="video-camera"
							style={{
								position: 'absolute',
								fontSize: '100px',
								top: `${
									this.state.videoContainerPosition.top +
									videoConstraints.video.height / 2 -
									50
								}px`,
								left: `${
									this.state.videoContainerPosition.left +
									videoConstraints.video.width / 2 -
									50
								}px`,
								color: '#424242',
								zIndex: '9',
							}}
						/>
						{!videoError && (
							<Icon
								type="loading"
								style={{
									position: 'absolute',
									fontSize: '30px',
									top: `${
										this.state.videoContainerPosition.top +
										videoConstraints.video.height / 2 -
										10
									}px`,
									left: `${
										this.state.videoContainerPosition.left +
										videoConstraints.video.width / 2 -
										22
									}px`,
									color: '#424242',
									zIndex: '9',
								}}
							/>
						)}

						{videoError && (
							<Icon
								type="exclamation-circle"
								style={{
									position: 'absolute',
									fontSize: '30px',
									top: `${
										this.state.videoContainerPosition.top +
										videoConstraints.video.height / 2 -
										10
									}px`,
									left: `${
										this.state.videoContainerPosition.left +
										videoConstraints.video.width / 2 -
										22
									}px`,
									color: 'rgba(255, 99, 71, 0.65)',
									zIndex: '9',
								}}
							/>
						)}
					</Fragment>
				) : null}
				<canvas
					id="main-canvas"
					className="shadow-effect"
					style={{
						position: 'absolute',
						top: `${this.state.videoContainerPosition.top}px`,
						left: `${this.state.videoContainerPosition.left}px`,
						pointerEvents: 'none',
						objectFit: 'contain',
						boxSizing: 'padding-box',
						borderStyle: 'solid',
						borderWidth: '4px',
						borderColor: '#f6f6f6',
						borderRadius: '4px',
						backgroundColor: '#f6f6f6',
					}}
					width={videoConstraints.video.width}
					height={videoConstraints.video.height}
				/>
				<canvas
					id="cropped-canvas"
					width={videoConstraints.video.width}
					height={videoConstraints.video.height}
					style={{
						position: 'absolute',
						top: `${
							this.state.videoContainerPosition.top +
							videoConstraints.video.height +
							50
						}px`,
						left: `${this.state.videoContainerPosition.left}px`,
						opacity: '1',
						pointerEvents: 'none',
						display: 'none',
						objectFit: 'contain',
						boxSizing: 'padding-box',
						borderStyle: 'solid',
						borderWidth: '4px',
						borderColor: '#f6f6f6',
						borderRadius: '4px',
						backgroundColor: '#f6f6f6',
					}}
				/>
				{Canvas &&
					Pointer &&
					videoConstraints &&
					videoConstraints.video &&
					videoConstraints.video.width &&
					videoConstraints.video.height &&
					!initialTrainingInProgress &&
					!this.rectCanvasCreated &&
					this.setupRectCanvas()}
				<Tooltip title={'Mirror video.'}>
					<div
						className={
							videoCropped || croppedHeight || croppedHeight ? '' : 'pulse'
						}
						style={{
							position: 'absolute',
							top: `${this.state.videoContainerPosition.top + 8}px`,
							left: `${this.state.videoContainerPosition.left + 12}px`,
							padding: '4px',
							backgroundColor: '#424242',
							borderRadius: '2px',
							color: '#f2f2f2',
							zIndex: '11',
							cursor: 'pointer',
							opacity: videoCropped ? '.4' : '1',
							pointerEvents: videoCropped ? 'none' : 'auto',
							visibility:
								!showClassCountSetter || videoError ? 'hidden' : 'visible',
							display: classCount && machineAwake ? 'none' : 'inherit',
						}}
					>
						<i
							id="mirror-image"
							className="fa fa-exchange"
							onClick={this.toggleMirroringOfVideoStream}
						/>
					</div>
				</Tooltip>

				{showClassCountSetter && !videoError ? (
					<div
						style={{
							position: 'absolute',
							top: `${
								this.state.videoContainerPosition.top +
								videoConstraints.video.height +
								12
							}px`,
							left: `${this.state.videoContainerPosition.left}px`,
							fontSize: '1em',
							color: '#008cff',
							marginTop: '2h',
							width: `${videoConstraints.video.width}px`,
							textAlign: 'center',
						}}
					>
						{!videoCropped && !croppedWidth && !croppedHeight ? (
							<div>
								<span>Drag mouse over the image to draw shape. </span>
								<span>
									Click on{' '}
									<i
										style={{
											padding: '2px',
											backgroundColor: '#424242',
											borderRadius: '2px',
											color: '#f2f2f2',
											cursor: 'pointer',
										}}
										className="fa fa-exchange"
										onClick={this.toggleMirroringOfVideoStream}
									/>{' '}
									to mirror the video if needed.
								</span>
							</div>
						) : null}
						{!videoCropped && croppedWidth && croppedHeight ? (
							<div>
								<span>
									Click on{' '}
									<i
										style={{
											padding: '2px',
											backgroundColor: '#1890ff',
											borderRadius: '2px',
											color: '#f2f2f2',
											cursor: 'pointer',
										}}
										className="fa fa-crop"
										onClick={this.handleCreatingCroppedCanvas}
									/>{' '}
									to set the area of interest.
								</span>
							</div>
						) : null}
						{videoCropped && croppedWidth && croppedHeight ? (
							<div>
								<span>
									Area of interest has been set.{' '}
									<span>
										Click on{' '}
										<i
											style={{
												padding: '2px',
												backgroundColor: 'rgba(46, 204, 113, 1)',
												borderRadius: '2px',
												color: '#f2f2f2',
												cursor: 'pointer',
											}}
											className="fa fa-refresh"
											onClick={this.resetCrop}
										/>
									</span>{' '}
									to remove the shape as area of interest.
								</span>
							</div>
						) : null}
					</div>
				) : null}
				<Tooltip title={'Set shape as area of interest.'}>
					<div
						className={!videoCropped ? 'pulse' : ''}
						style={{
							position: 'absolute',
							top: `${this.state.videoContainerPosition.top + 8}px`,
							left: `${this.state.videoContainerPosition.left + 38}px`,
							padding: '4px',
							backgroundColor: '#1890ff',
							borderRadius: '2px',
							color: '#f2f2f2',
							zIndex: '11',
							cursor: 'pointer',
							visibility:
								!videoCropped &&
								showClassCountSetter &&
								croppedWidth &&
								Math.abs(croppedWidth) > 0 &&
								croppedHeight &&
								Math.abs(croppedHeight) > 0
									? 'visible'
									: 'hidden',
							display:
								(videoCropped &&
									showClassCountSetter &&
									croppedWidth &&
									Math.abs(croppedWidth) > 0 &&
									croppedHeight &&
									Math.abs(croppedHeight) > 0) ||
								(classCount && machineAwake)
									? 'none'
									: 'inherit',
						}}
					>
						<i
							id="set-crop"
							className="fa fa-crop"
							onClick={this.handleCreatingCroppedCanvas}
						/>
					</div>
				</Tooltip>
				<Tooltip title={'Reset shape as area of interest.'}>
					<div
						className={videoCropped ? 'pulse' : ''}
						style={{
							position: 'absolute',
							top: `${this.state.videoContainerPosition.top + 8}px`,
							left: `${this.state.videoContainerPosition.left + 38}px`,
							padding: '4px',
							backgroundColor: 'rgba(46, 204, 113, 1)',
							borderRadius: '2px',
							color: '#f2f2f2',
							zIndex: '11',
							cursor: 'pointer',
							display:
								videoCropped &&
								showClassCountSetter &&
								croppedWidth &&
								Math.abs(croppedWidth) > 0 &&
								croppedHeight &&
								Math.abs(croppedHeight) > 0
									? 'inherit'
									: 'none',
						}}
					>
						<i
							id="reset-crop"
							className="fa fa-refresh"
							onClick={this.resetCrop}
						/>
					</div>
				</Tooltip>
				{showClassCountSetter && (
					<div
						style={{
							position: 'absolute',
							top: `${this.state.videoContainerPosition.top + 50}px`,
							right: `${this.state.videoContainerPosition.left + 50}px`,
						}}
					>
						<div
							className="class-slider"
							style={{
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
								flexDirection: 'column',
								textAlign: 'center',
							}}
						>
							<h4 style={{ fontWeight: '200%', width: '320px' }}>
								Use the Slider below to set{' '}
								<span style={{ color: '#1890ff' }}>
									<Icon type="number" /> OF CLASSES
								</span>{' '}
								to teach the AI to recognize
							</h4>

							<Slider
								style={{ marginTop: '2vh', width: '260px' }}
								marks={marks}
								// tooltipVisible
								min={MIN_CLASSES_ALLOWED}
								max={MAX_CLASSES_ALLOWED}
								onChange={this.setClassCount}
								onAfterChange={this.setClassCount}
							/>
							{classCount &&
								ml5 &&
								showWakeUpMachine &&
								featureExtractor &&
								knnClassifier && (
									<Button
										style={{
											marginBottom: '5vh',
											marginTop: '5vh',
											textAlign: 'center',
										}}
										className={'wakeUpMachine_btn'}
										loading={loading}
										type="primary"
										onClick={this.wakeUpMachine}
									>
										WakeUp AI
									</Button>
								)}
						</div>
					</div>
				)}
				{classCount && machineAwake && (
					<div>
						<div
							style={{
								position: 'absolute',
								top: `${
									this.state.videoContainerPosition.top +
									videoConstraints.video.height +
									12
								}px`,
								left: `${this.state.videoContainerPosition.left}px`,
								textAlign: 'center',
							}}
						>
							<p
								style={{
									fontSize: '1em',
									color: '#008cff',
									width: videoConstraints.video.width,
								}}
							>
								<Icon type="info-circle" /> Minimum of {REQUIRED_TRAINING_COUNT}{' '}
								training examples required for each class.
							</p>
							<div
								style={{
									width: `${videoConstraints.video.width}px`,
								}}
							>
								<Popconfirm
									title={`Add a New Class?`}
									okText={'Add'}
									cancelText={'Cancel'}
									onConfirm={this.addAnotherClass}
									icon={
										<Icon type="question-circle-o" style={{ color: 'red' }} />
									}
								>
									<Tooltip placement="bottom" title="Add Class">
										<Button
											className={'addAnotherClass_btn'}
											style={{ marginRight: '6px' }}
											type="primary"
											icon="plus"
											disabled={classCount >= MAX_CLASSES_ALLOWED}
										/>
									</Tooltip>
								</Popconfirm>
								<Tooltip placement="bottom" title="Edit Class Labels">
									<Button
										className={'showClassLabelModal_btn'}
										style={{ marginRight: '6px' }}
										type="primary"
										icon="edit"
										onClick={this.showClassLabelModal}
									/>
								</Tooltip>

								<Popconfirm
									title={`Delete training for all Classes?`}
									okText={'Delete'}
									cancelText={'Cancel'}
									onConfirm={this.clearAllTrainingForAllClasses}
									icon={
										<Icon type="question-circle-o" style={{ color: 'red' }} />
									}
								>
									<Tooltip
										title="Delete training for all Classes"
										placement="bottom"
									>
										<Button
											style={{ marginRight: '6px' }}
											type="danger"
											icon="delete"
											className={'clearAllTrainingForAllClasses_btn'}
										/>
									</Tooltip>
								</Popconfirm>
								<Popconfirm
									title={`Save Trained Model?`}
									okText={'Save'}
									cancelText={'Cancel'}
									onConfirm={this.saveTrainedModel}
									icon={
										<Icon type="question-circle-o" style={{ color: 'red' }} />
									}
								>
									<Tooltip title="Save Trained Model" placement="bottom">
										<Button
											style={{ marginRight: '6px' }}
											type="primary"
											icon="save"
											className={'saveTrainedModel_btn'}
										/>
									</Tooltip>
								</Popconfirm>
								<Upload {...modelFileUploaderProps} showUploadList={false}>
									<Tooltip title="Load Trained Model" placement="bottom">
										<Button
											type="primary"
											icon="upload"
											className={'loadTrainedModel_btn'}
										/>
									</Tooltip>
								</Upload>
							</div>
							{minimumTrainingMet && (
								<div
									style={{
										display: 'flex',
										justifyContent: 'center',
										alignItems: 'center',
										marginTop: '2vh',
										marginBottom: '5vh',
									}}
								>
									<Upload {...fileClassifyUploaderProps} showUploadList={false}>
										<Tooltip
											placement="bottom"
											title={'Upload & Classify an Image File'}
										>
											<Button
												type={'default'}
												className={'classifyImage_btn'}
												style={{
													width: '160px',
												}}
											>
												Classify Image
											</Button>
										</Tooltip>
									</Upload>
									<Tooltip
										placement="bottom"
										title={
											videoClassifierRunning
												? 'Stop Classifying Video'
												: 'Begin Classifying Video'
										}
									>
										<Button
											type={videoClassifierRunning ? 'danger' : 'default'}
											style={{
												width: '160px',
												marginLeft: '12px',
											}}
											disabled={videoError}
											className={
												videoClassifierRunning
													? 'stopVideoClassify_btn'
													: 'startVideoClassify_btn'
											}
											onClick={
												!videoClassifierRunning
													? this.startVideoClassifying
													: this.stopVideoClassifying
											}
										>
											{videoClassifierRunning ? (
												<span>
													Stop <Icon type="video-camera" /> Classify
												</span>
											) : (
												<span>
													Start <Icon type="video-camera" /> Classify
												</span>
											)}
										</Button>
									</Tooltip>
								</div>
							)}
						</div>

						<Modal
							className="classLabelingModal"
							title={
								<div style={{ color: '#1890ff', textAlign: 'center' }}>
									Label the Classes
								</div>
							}
							visible={classLabelingModalVisible}
							onOk={this.handleClassLabelingModalOk}
							okButtonProps={{ disabled: true }}
							footer={[
								this.state.addAnotherClassInProgress ? (
									<Button
										key="cancel"
										onClick={this.handleClassLabelingModalCancel}
										className={'setLabelsCancel_btn'}
									>
										Cancel
									</Button>
								) : null,
								<Button
									key="submit"
									type="primary"
									disabled={!allClassesHaveLabels || !uniqueClassLabels}
									onClick={this.handleClassLabelingModalOk}
									className={'setLabels_btn'}
								>
									Set Labels
								</Button>,
							]}
						>
							{classCountArray.map((val, index) => {
								return (
									<Input
										key={`${val}`}
										style={{ marginBottom: 16 }}
										placeholder={`Enter label for class # ${val + 1}`}
										value={classLabelObject[`${val}`]}
										onChange={(event) =>
											this.onClassLabelChange({
												event,
												classIndex: `${val}`,
											})
										}
										onKeyPress={(e) => this.onClassLabelingEnter(e)}
									/>
								)
							})}
							<Icon style={{ color: '#424242' }} type="info-circle" />{' '}
							<span
								style={{
									color: '#424242',
									fontSize: '0.85em',
									textAlign: 'center',
								}}
							>
								Each label must be unique
							</span>
						</Modal>
						<div>
							<Row
								style={{
									position: 'absolute',
									top: `${this.state.videoContainerPosition.top - 8}px`, // -8 because of the border used on canvas
									right: `${this.state.videoContainerPosition.left}px`,
								}}
								gutter={16}
							>
								{classCountArray.map((val) => {
									return (
										<Col key={`${val}`}>
											<Badge
												count={countByClassIndexObject[`${val}`] || 0}
												overflowCount={999}
											>
												<Card
													className={'fadeIn classCard shadow-effect'}
													title={
														classLabelObject[`${val}`]
															? classLabelObject[`${val}`].toUpperCase()
															: `Class# ${val + 1}`
													}
													bordered={true}
													style={{
														width: 240,
														border: '2px',
													}}
												>
													<div
														style={{
															display: 'flex',
															justifyContent: 'center',
															alignItems: 'center',
														}}
													/>
													<UploadDir
														key={`${val}`}
														classIndex={`${val}`}
														classLabelObject={classLabelObject}
														fileTrainingRunning={fileTrainingRunning}
														style={{
															position: 'absolute',
															left: '0px',
															bottom: '0px',
															width: '40%',
															borderRadius: '0px',
														}}
														handleSuccess={this.handleUploadSuccess}
													/>
													<Tooltip
														placement="bottom"
														title={`Train Class from video snapshot`}
													>
														<Button
															type="primary"
															value={`${val}`}
															icon="video-camera"
															className={'trainClass_btn'}
															style={{
																position: 'absolute',
																left: '40%',
																bottom: '0px',
																width: '40%',
																borderRadius: '0px',
															}}
															onClick={this.trainClass}
														>
															<span>Train</span>
														</Button>
													</Tooltip>
													<Popconfirm
														title={`Delete all training data for class: ${
															classLabelObject[`${val}`]
														}`}
														okText={'Delete'}
														cancelText={'Cancel'}
														onConfirm={() =>
															this.clearAllTrainingExamplesInClass({
																classIndex: `${val}`,
															})
														}
														icon={
															<Icon
																type="question-circle-o"
																style={{ color: 'red' }}
															/>
														}
													>
														<Tooltip
															placement="bottom"
															title={`Delete all training data for class`}
														>
															<Button
																className={'deleteClassTrainingData_btn'}
																style={{
																	position: 'absolute',
																	right: '0px',
																	bottom: '0px',
																	width: '20%',
																	border: '2px',
																	borderRadius: '0px',
																}}
																type="danger"
																icon="delete"
																value={`${val}`}
															/>
														</Tooltip>
													</Popconfirm>
												</Card>
											</Badge>
										</Col>
									)
								})}
							</Row>
						</div>
					</div>
				)}
			</div>
		)
	}
}
export default withRouter(Teach)

const marks = {
	2: '2',
	3: '3',
	4: '4',
	5: '5',
}
